import { createActions } from 'redux-actions';

export const actions = createActions({
  SUSTAINABILITY: {
    SET_ACTIVE_PERIOD: payload => payload,
    SET_SOCIAL_RESPONSIBILITY_ACTIVE_SLIDE: (payload) => payload,
  },
}).sustainability;
